import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import EditRemoveReasonDetail from "./Forms/RemoveReasonDetailEditForm";
import { TitleRemoveReasonTypeDetails } from "./Constant/Source";

const RemoveReasonEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleRemoveReasonTypeDetails.edit} component="div">
      <EditRemoveReasonDetail {...props} />
    </Edit>
  );
};

export default RemoveReasonEdit;
